import React, { createContext, useContext, useMemo, useState } from 'react';

export const SearchInputContext = createContext();

export const SearchInputProvider = ({ children, isIframe }) => {
  const [focused, setFocused] = useState(false);

  const state = useMemo(() => ({ focused, isIframe, setFocused }), [focused, isIframe]);

  return <SearchInputContext.Provider value={state}>{children}</SearchInputContext.Provider>;
};

export const useSearchInputState = () => useContext(SearchInputContext);
